import 'react-quill/dist/quill.snow.css';
import AssetUpload from 'components/AssetUpload';
import { Card, Form, Input } from 'antd';
import { EcommerceIconComponent } from 'assets/icons/ecommerce';
import { EditLayout } from 'components/layout/layout/EditLayout';
import { ITestimonial } from 'interfaces/testimonials';
import { PageHeader } from 'components/professor_area/PageHeader';
import { useForm } from '@refinedev/antd';

export const TestimonialEdit = () => {
  const { formProps, saveButtonProps, queryResult } = useForm<ITestimonial>({
    redirect: 'edit'
  });

  return (
    <EditLayout saveButtonProps={saveButtonProps} title="Editar depoimento">
      <PageHeader
        title={formProps.initialValues?.title}
        icon={EcommerceIconComponent}
      />

      <Card>
        <Form {...formProps} layout="vertical">
          <Form.Item
            label="Imagem para Depoimento"
            name={['image', 'testimonial_section_image']}
            rules={[
              {
                required: false
              }
            ]}
          >
            <AssetUpload
              accept="image/png, image/jpeg"
              type="testimonial"
              src={queryResult?.data?.data?.image?.testimonial_section_image}
            />
          </Form.Item>

          <Form.Item
            label="Título"
            name="title"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Subtítulo"
            name="subtitle"
            rules={[
              {
                required: false
              }
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Descrição"
            name="description"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input.TextArea />
          </Form.Item>
        </Form>
      </Card>
    </EditLayout>
  );
};
